export enum HearingSensations {
  Good = "good",
  Bad = "bad",
  Medium = "medium",
}